import type { ComponentType } from "react";
import {
  IconAddressBook,
  IconArrowLeft,
  IconChevronDown,
  IconEdit,
  IconEye,
  IconFilter,
  IconFolder,
  IconFolders,
  IconMail,
  IconMapPin,
  IconPlus,
  IconRefresh,
  IconSearch,
  IconSettings,
  IconTrash,
  IconUpload,
  IconUsers,
  IconX,
} from "@tabler/icons-react";

export type ContactsIconName =
  | "address-book"
  | "arrow-left"
  | "chevron-down"
  | "edit"
  | "eye"
  | "filter"
  | "folder"
  | "folders"
  | "mail"
  | "map-pin"
  | "plus"
  | "refresh"
  | "search"
  | "settings"
  | "trash"
  | "upload"
  | "users"
  | "x";

type IconComponentProps = {
  className?: string;
  size?: string | number;
  stroke?: string | number;
  "aria-hidden"?: boolean;
};

const ICONS: Record<ContactsIconName, ComponentType<IconComponentProps>> = {
  "address-book": IconAddressBook,
  "arrow-left": IconArrowLeft,
  "chevron-down": IconChevronDown,
  edit: IconEdit,
  eye: IconEye,
  filter: IconFilter,
  folder: IconFolder,
  folders: IconFolders,
  mail: IconMail,
  "map-pin": IconMapPin,
  plus: IconPlus,
  refresh: IconRefresh,
  search: IconSearch,
  settings: IconSettings,
  trash: IconTrash,
  upload: IconUpload,
  users: IconUsers,
  x: IconX,
};

export function ContactsIcon({
  name,
  className = "ui-icon",
  size = "1em",
  stroke = 1.9,
}: {
  name: ContactsIconName;
  className?: string;
  size?: string | number;
  stroke?: string | number;
}) {
  const Component = ICONS[name];
  return <Component className={className} size={size} stroke={stroke} aria-hidden={true} />;
}

export function ContactsIconLabel({
  icon,
  label,
}: {
  icon: ContactsIconName;
  label: string;
}) {
  return (
    <span className="icon-label">
      <ContactsIcon name={icon} />
      <span>{label}</span>
    </span>
  );
}
